import { Card } from "@fanduel/og-fe-library";
import { useEffect } from "react";
import AuthorArticleFeed from "@/components/author/AuthorArticlesFeed";
import FeaturedBet from "@/components/author/featuredBet";
import AuthorInfo from "@/components/container/Author/AuthorInfo";
import AuthorList from "@/components/container/Author/AuthorList";
import { AUTHOR_PAGE_VIEWED } from "@/constants/amplitude";
import { ContentAuthor } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useOnce from "@/utils/hooks/useOnce";
import styles from "./authorContainer.module.scss";

interface AuthorContainerProps {
  author: ContentAuthor;
  authors: ContentAuthor[];
}

export default function AuthorContainer({
  author,
  authors,
}: AuthorContainerProps) {
  const { logAmplitudeEvent, setPage } = useAmplitude();
  const ampFavoriteSports = JSON.stringify(
    author.favoriteSports?.map((sport) => sport?.name)
  );

  useEffect(() => {
    logAmplitudeEvent(AUTHOR_PAGE_VIEWED, {
      Author: author.name,
      "Favorite Competitions": ampFavoriteSports,
      "Page Name": "author",
    });
  }, [ampFavoriteSports, author, logAmplitudeEvent]);

  useOnce(() => {
    setPage("author");
  });
  return (
    <div className={styles.container}>
      <Card className={styles.card} variant="elevation" elevation="low">
        <AuthorInfo author={author} />
        {author.featuredBet?.market ? (
          <FeaturedBet featuredBet={author.featuredBet} name={author.name} />
        ) : null}
        <AuthorArticleFeed author={author} />
      </Card>
      <AuthorList pageAuthorName={author.name} authors={authors} />
    </div>
  );
}
